import axiosClient from "./axiosClient";
import { ApiResponse } from "models";
import {
  QuotationPayload,
  QuotationListParams,
  SelectOptionPayload,
  SendQuotationPayload,
  SendDocumentPayload,
  CreateContractPayload,
  UploadSignedContractPayload,
} from "models/quotation";

const quotationApi = {
  // Step 1: Create Quotation (Creates a new quotation with status: DRAFT)
  createQuotation(payload: QuotationPayload): Promise<ApiResponse> {
    const url = "/quotation/create";
    return axiosClient.post<ApiResponse>(url, payload);
  },

  // Step 2: Update Quotation (Pass Quotation ID while in DRAFT status)
  updateQuotation(payload: QuotationPayload): Promise<ApiResponse> {
    const url = "/quotation/create";
    return axiosClient.post<ApiResponse>(url, payload);
  },

  // Send Document (Quotation or Contract) via Email & WhatsApp
  // PATCH /quotation/sendDocument
  sendDocument(payload: SendDocumentPayload): Promise<ApiResponse> {
    const url = "/quotation/sendDocument";
    return axiosClient.patch<ApiResponse>(url, payload);
  },

  // Step 3: Send Quotation (Updates status to SENT and locks editing)
  sendQuotation(payload: SendQuotationPayload): Promise<ApiResponse> {
    const docPayload: SendDocumentPayload = {
      type: payload.type || "QUOTATION",
      id: payload.id || payload.quotationId || "",
      emailToSend: payload.emailToSend !== undefined ? payload.emailToSend : true,
      whatsappToSend: payload.whatsappToSend !== undefined ? payload.whatsappToSend : true,
    };
    return this.sendDocument(docPayload);
  },

  // Step 4: Select Option (Accept chosen option, sets selectedOptionId & ACCEPTED status)
  selectOption(payload: SelectOptionPayload): Promise<ApiResponse> {
    const url = "/quotation/selectOption";
    return axiosClient.post<ApiResponse>(url, payload);
  },

  // Step 5: Create Formal Contract (Generates contract with status: PENDING_SIGNATURE)
  createContract(payload: CreateContractPayload): Promise<ApiResponse> {
    const url = "/quotation/createContract";
    return axiosClient.post<ApiResponse>(url, payload);
  },

  // Step 6: Upload Signed Contract & Activate (Attaches signed PDF URL and updates status to ACTIVE)
  uploadSignedContract(payload: UploadSignedContractPayload): Promise<ApiResponse> {
    const url = "/quotation/uploadSignedContract";
    return axiosClient.post<ApiResponse>(url, payload);
  },

  // Cancel Quotation
  cancelQuotation(id: string): Promise<ApiResponse> {
    const url = "/quotation/cancel";
    return axiosClient.patch<ApiResponse>(url, { id });
  },

  // Fetch Quotation List
  getQuotations(params: QuotationListParams = {}): Promise<any> {
    const queryParams = new URLSearchParams();
    if (params.page) queryParams.append("page", String(params.page));
    if (params.limit) queryParams.append("limit", String(params.limit));
    if (params.customerId) queryParams.append("customerId", params.customerId);
    if (params.status) queryParams.append("status", params.status);
    if (params.search) queryParams.append("search", params.search);
    if (params.sortField) queryParams.append("sortField", params.sortField);
    if (params.sortType) queryParams.append("sortType", params.sortType);

    const queryString = queryParams.toString();
    const url = `/quotation/getAll${queryString ? `?${queryString}` : ""}`;
    return axiosClient.get(url);
  },

  // Fetch Quotation Details by ID
  getQuotationById(id: string): Promise<ApiResponse> {
    const url = `/quotation/getById?id=${encodeURIComponent(id)}`;
    return axiosClient.get(url);
  },
};

export default quotationApi;
